import { Logger } from "@wemade-vsf/core";
const loadQuoteCartCommand = {
  execute: async (context, params) => {
    const apiState = context.$magento.config.state;
    Logger.debug("[Magento Storefront]: Loading Quote Cart");
    const customerToken = apiState.getCustomerToken();
    const virtual = !params.realCart;
    const createVirtualCart = () => null;
    const createRealCart = async () => {
      Logger.debug("[Magento Storefront]: useQuoteCart.load.createNewCart");
      apiState.setQuoteCartId();
      const { data } = await context.$magento.api.createEmptyQuoteCart();
      Logger.debug("[Result]:", { data });
      apiState.setQuoteCartId(data.createEmptyQuoteCart);
      return data.createEmptyQuoteCart;
    };
    const getCartData = async (id) => {
      Logger.debug("[Magento Storefront]: useQuoteCart.load.getCartData ID->", id);
      const { data, errors } = await context.$magento.api.quoteCart(id);
      Logger.debug("[Result]:", { data });
      if (!(data == null ? void 0 : data.quoteCart) && (errors == null ? void 0 : errors.length)) {
        throw errors[0];
      }
      data.quoteCart.items = data.quoteCart.items.filter(Boolean);
      return data.quoteCart;
    };
    const getCart = async (virtualCart, cartId) => {
      if (!cartId) {
        if (virtualCart) {
          return createVirtualCart();
        }
        cartId = await createRealCart();
        apiState.setQuoteCartId(cartId);
      }
      return getCartData(cartId);
    };
    if (customerToken) {
      try {
        const { data, errors } = await context.$magento.api.customerQuoteCart();
        Logger.debug("[Result]:", { data, errors });
        if (!(data == null ? void 0 : data.customerQuoteCart) && (errors == null ? void 0 : errors.length)) {
          throw errors[0];
        }
        apiState.setQuoteCartId(data.customerQuoteCart.id);
        data.customerQuoteCart.items = data.customerQuoteCart.items.filter(Boolean);
        return data.customerQuoteCart;
      } catch {
        apiState.setCustomerToken();
      }
    }
    try {
      const quoteCartId = apiState.getQuoteCartId();
      return await getCart(virtual, quoteCartId);
    } catch {
      apiState.setQuoteCartId();
      return await getCart(virtual);
    }
  }
};
export {
  loadQuoteCartCommand
};
